import { useMemo } from 'react';

// Deterministic initials-avatar. Colour is hashed from the name so the same person is
// always the same colour without storing anything.
const PALETTE: Array<[string, string]> = [
  ['oklch(0.78 0.10 60)', 'oklch(0.25 0.05 40)'],
  ['oklch(0.78 0.10 200)', 'oklch(0.20 0.06 240)'],
  ['oklch(0.80 0.10 140)', 'oklch(0.25 0.06 150)'],
  ['oklch(0.80 0.10 320)', 'oklch(0.25 0.06 320)'],
  ['oklch(0.82 0.06 85)', 'oklch(0.22 0.04 250)'],
];

const SIZES = {
  sm: 'w-[22px] h-[22px] text-[9.5px]',
  md: 'w-7 h-7 text-[11px]',
  lg: 'w-10 h-10 text-[13px]',
} as const;

interface AvatarProps {
  name?: string;
  size?: keyof typeof SIZES;
  title?: string;
}

export function Avatar({ name = '?', size = 'md', title }: AvatarProps) {
  const initials = useMemo(() => {
    const parts = name.trim().split(/\s+/);
    return ((parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '')).toUpperCase() || '?';
  }, [name]);

  const [bg, fg] = useMemo<[string, string]>(() => {
    let s = 0;
    for (let i = 0; i < name.length; i++) s = (s + name.charCodeAt(i)) % PALETTE.length;
    return PALETTE[s] ?? ['oklch(0.82 0.06 85)', 'oklch(0.22 0.04 250)'];
  }, [name]);

  return (
    <span
      className={
        'inline-flex flex-none items-center justify-center rounded-full font-semibold ' + SIZES[size]
      }
      style={{ background: bg, color: fg }}
      title={title ?? name}
    >
      {initials}
    </span>
  );
}
